import React, { useState, useEffect } from "react";
import "./Navbar.css";

import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import logo from "../../images/logo_black.png";
import { CgMenuRightAlt } from "react-icons/cg";
import { waMessages } from "../../Utils/waMessages";
import SaveTheWaves from "../../images/save_the_waves.png";
import { PiInstagramLogo, PiWhatsappLogo } from "react-icons/pi";
import { FullScreenNavbar } from "../FullscreenNavbar/FullscreenNavbar";

export const Navbar = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleTouchEndOpen = (e) => {
    e.preventDefault();
    setIsMenuOpen(true);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const addBackground = () => {
    if (location.pathname === "/activities") return "scrolled";
    return isScrolled ? "scrolled" : "";
  };

  return !isMenuOpen ? (
    <nav className={`navbar ${addBackground()}`}>
      <div className="navbar__left-content">
        <Link to="/">
          <img
            className={`navbar__logo ${addBackground()}`}
            alt="TIDE Surfing school"
            src={logo}
          />
        </Link>
        <Link
          className="navbar__save-the-waves-image"
          to="https://www.savethewaves.org/puertoescondido/"
          target="_blank"
        >
          <img src={SaveTheWaves} alt="Save The Waves Coallition" />
        </Link>
      </div>
      <ul className="navbar__menu">
        <li className="navbar__item">
          <Link
            to="about-us"
            className={
              location.pathname === "/about-us"
                ? "navbar__link active"
                : "navbar__link"
            }
          >
            Nosotros
          </Link>
        </li>
        <li className="navbar__item">
          <Link
            to="activities"
            className={
              location.pathname === "/activities"
                ? "navbar__link active"
                : "navbar__link"
            }
          >
            Actividades
          </Link>
        </li>
        <li className="navbar__item">
          <Link
            to="gallery"
            className={
              location.pathname === "/gallery"
                ? "navbar__link active"
                : "navbar__link"
            }
          >
            Galeria
          </Link>
        </li>
        <li className="navbar__item">
          <a
            href="https://www.instagram.com/tide_surfpuertoescondido/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PiInstagramLogo className="navbar__icon" color="black" size={25} />
          </a>
        </li>
        <li className="navbar__item">
          <a
            href={`https://wa.me/529541686583?text=${waMessages.general}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PiWhatsappLogo className="navbar__icon" color="black" size={25} />
          </a>
        </li>
      </ul>
      <button
        className="navbar__toggle"
        onClick={() => setIsMenuOpen(true)}
        onTouchEnd={handleTouchEndOpen}
      >
        <CgMenuRightAlt size={32} />
      </button>
    </nav>
  ) : (
    <FullScreenNavbar
      logo={logo}
      closeNavbarMenu={() => setIsMenuOpen(false)}
    />
  );
};
